import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDataVizState } from '../store/selectors/dataVizSelector';
import VideoCarousel from '../VideoCarousel';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import contentGraphDatasource from '@gameday/core/datasources/contentGraph';
import contentDatasource from '@gameday/core/datasources/content';
import dataAction from '../store/actions/VideoCarouselDataRequestAction';
import { switchActiveTab } from '../../Final/store/actions/final';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';

const actions = (dispatch) => ({
    handleTabChange: (activeTab) => {
        dispatch(switchActiveTab(activeTab));
    }
});

initContainerData.register({
    datasources: {
        content: contentDatasource,
        contentGraph: contentGraphDatasource
    }
});

const fetchData = () => {
    return dataAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const DataVizDataContainer = ({
    handlers
}) => {
    const dispatch = useDispatch();
    const translate = useTranslate();
    const title = translate('label_data_visualizations', 'Data Visualizations');
    const {
        dataViz,
        deviceInteraction,
        isLoading,
        language,
        appPath
    } = useSelector(getDataVizState);
    return (
        <VideoCarousel
            { ...actions(dispatch) }
            isLoading={ isLoading }
            deviceInteraction={deviceInteraction}
            handlers={ handlers }
            language={ language }
            appPath={ appPath }
            highlights={dataViz}
            showStory={ false }
            title={ title }
            showFilmRoomLink={ false }
            width={'298px'}
            playerContext={'Data Visualizations Carousel'}
        />
    );
};

export default DataVizDataContainer;
export { fetchData, routes };
